module.exports = __webpack_public_path__ + "img/chijieban3.bbba9b70.jpg";